<template>
    <div class="heatstroke-body">
        <MeasurementPanel
            :meterImage="meterImage"
            :currentWeatherData="currentWeatherData"
        />
        <Level1 v-if="currentLevel === 1" :date="date" />
        <Level2 v-else-if="currentLevel === 2" :date="date" />
        <Level3 v-else-if="currentLevel === 3" :date="date" />
        <Level4 v-else-if="currentLevel === 4" :date="date" />
        <Level5 v-else :date="date" />
    </div>
    <!-- ./level-1 -->
</template>

<script>
import MeasurementPanel from "./MeasurementPanel";
import Level1 from "./Level1";
import Level2 from "./Level2";
import Level3 from "./Level3";
import Level4 from "./Level4";
import Level5 from "./Level5";

export default {
    data() {
        return {
            weatherData: {},
            currentWeatherData: {},
            assetPath: "/files/items/heatstroke"
        };
    },
    components: {
        Level1,
        Level2,
        Level3,
        Level4,
        Level5,
        MeasurementPanel
    },
    computed: {
        currentLevel() {
            return this.currentWeatherData.wbgtIndex;
        },
        date() {
            return this.currentWeatherData.forecastDateTime.format(
                "M月D日 H:mm"
            );
        },
        meterImage() {
            return (
                this.assetPath +
                "/meter/meter_" +
                this.currentWeatherData.wbgtIndex +
                ".png"
            );
        },
        characterImage() {
            return (
                this.assetPath +
                "/character/character_" +
                this.currentWeatherData.wbgtIndex +
                ".png"
            );
        },
        sunImage() {
            return (
                this.assetPath +
                "/sun/sun_" +
                this.currentWeatherData.wbgtIndex +
                ".png"
            );
        }
    },
    methods: {
        // window.nowと比較して、現在の気象データをセットする
        updateCurrentWeatherData() {
            const now = moment();
            for (const key in heatstrokeWeatherDataList) {
                if (heatstrokeWeatherDataList.hasOwnProperty(key)) {
                    const hourlyWeatherData = heatstrokeWeatherDataList[key];
                    if (hourlyWeatherData.forecastDateTime.isAfter(now)) {
                        return;
                    }
                    this.currentWeatherData = hourlyWeatherData;
                }
            }
        },
        // 定期的に現在のデータをチェックして古ければ更新
        updateCurrentWeatherDataRegularly() {
            const test1 = moment()
                .startOf("hour")
                .format("YYYY-MM-DD HH:mm:ss");
            const test2 = this.currentWeatherData.forecastDateTime.format(
                "YYYY-MM-DD HH:mm:ss"
            );
            if (
                moment()
                    .startOf("hour")
                    .isAfter(this.currentWeatherData.forecastDateTime)
            ) {
                this.updateCurrentWeatherData();
            }
        },
        // forecastDateTimeの値をmomentインスタンスに変換する
        transformStringToMoment(heatstrokeWeatherDataList) {
            for (const key in heatstrokeWeatherDataList) {
                if (heatstrokeWeatherDataList.hasOwnProperty(key)) {
                    const hourlyWeatherData = heatstrokeWeatherDataList[key];
                    const date = new Date(hourlyWeatherData.forecastDateTime);
                    hourlyWeatherData.forecastDateTime = window.moment(
                        date.toISOString()
                    );
                }
            }
            return heatstrokeWeatherDataList;
        }
    },
    created() {
        this.weatherData = this.transformStringToMoment(
            heatstrokeWeatherDataList
        );
        this.updateCurrentWeatherData();
        setInterval(this.updateCurrentWeatherDataRegularly, 60 * 1000);
        console.log(
            "熱中症:緯度経度",
            heatstrokeLocation.lat,
            heatstrokeLocation.lon
        );
    }
};
</script>
